import { IContext } from '@/api';
import { EditedRelocationLimit } from '.';
import { SaveRelocationLimit } from './SaveRelocationLimit';

export class SaveRelocationLimitsContext
    implements IContext {

    public readonly relocationLimits_Partial: SaveRelocationLimit[];

    constructor(relocationLimits: EditedRelocationLimit[]) {
        if (!relocationLimits) {
            this.relocationLimits_Partial = [];
        } else {
            this.relocationLimits_Partial = relocationLimits.map(
                x => new SaveRelocationLimit(x)
            );
        }
    }
}
